import { createTheme } from "@mui/material";

const theme = createTheme({
  palette: {
    primary: {
      main: "#010101",
    },
  },
});
export default theme;
